import { FamilyMember } from '@/types';

interface MemberSearchResultsProps {
  results: Array<{ member: FamilyMember; lineage: string }>;
  onSelect: (member: FamilyMember) => void;
}

export function MemberSearchResults({ results, onSelect }: MemberSearchResultsProps) {
  if (results.length === 0) return null;

  return (
    <div className="absolute z-50 w-full mt-1 bg-white rounded-lg shadow-lg border max-h-96 overflow-y-auto">
      {results.map(({ member, lineage }) => (
        <button
          key={member.id}
          type="button"
          onClick={() => onSelect(member)}
          className="w-full text-right px-4 py-3 hover:bg-gray-50 border-b last:border-b-0 transition-colors"
        >
          <div className="text-sm text-gray-600 leading-relaxed whitespace-normal break-words">
            {lineage}
          </div>
        </button>
      ))}
    </div>
  );
}